webpackJsonp([0],{

/***/ "./components/post-detail.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	var _heart = __webpack_require__("./node_modules/react-icons/lib/fa/heart.js");
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _typography = __webpack_require__("./utils/typography.js");
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _reactGravatar = __webpack_require__("./node_modules/react-gravatar/dist/index.js");
	
	var _reactGravatar2 = _interopRequireDefault(_reactGravatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostDetail = function (_React$Component) {
	  _inherits(PostDetail, _React$Component);
	
	  function PostDetail() {
	    _classCallCheck(this, PostDetail);
	
	    return _possibleConstructorReturn(this, (PostDetail.__proto__ || Object.getPrototypeOf(PostDetail)).call(this));
	  }
	
	  _createClass(PostDetail, [{
	    key: 'render',
	    value: function render() {
	      var _props$post = this.props.post,
	          image = _props$post.image,
	          likes = _props$post.likes,
	          id = _props$post.id,
	          username = _props$post.username,
	          weeksAgo = _props$post.weeksAgo,
	          text = _props$post.text;
	      var big = image.children[0].big;
	
	
	      var UserBar = function UserBar() {
	        return Glamor.createElement(
	          'div',
	          {
	            css: _defineProperty({}, _glamor.presets.Tablet, {
	              marginBottom: 'calc(' + (0, _typography.rhythm)(3 / 4) + ' + 1px)',
	              borderBottom: '1px solid rgba(0,0,0,0.1)'
	            })
	          },
	          Glamor.createElement(_reactGravatar2.default, {
	            size: 25,
	            email: 'mathews.kyle@gmail.com',
	            css: {
	              borderRadius: '100%',
	              float: 'left',
	              margin: 0,
	              marginRight: (0, _typography.rhythm)(1 / 2)
	            }
	          }),
	          Glamor.createElement(
	            'h5',
	            {
	              css: {
	                lineHeight: (0, _typography.rhythm)(1),
	                marginBottom: (0, _typography.rhythm)(3 / 4)
	              }
	            },
	            username
	          )
	        );
	      };
	
	      var PostDetails = function PostDetails() {
	        return Glamor.createElement(
	          'div',
	          {
	            css: _extends({}, (0, _typography.scale)(-2 / 5), {
	              lineHeight: _typography2.default.options.baseLineHeight
	            })
	          },
	          Glamor.createElement(
	            'div',
	            {
	              css: {
	                marginBottom: (0, _typography.rhythm)(1),
	                overflow: 'hidden'
	              }
	            },
	            Glamor.createElement(
	              'strong',
	              {
	                css: {
	                  float: 'left'
	                }
	              },
	              likes,
	              ' likes'
	            ),
	            Glamor.createElement(
	              'strong',
	              {
	                css: {
	                  color: 'rgba(0,0,0,0.4)',
	                  float: 'right'
	                }
	              },
	              weeksAgo,
	              'w'
	            )
	          ),
	          Glamor.createElement(
	            'div',
	            null,
	            Glamor.createElement(
	              'strong',
	              null,
	              username
	            ),
	            ' ',
	            text
	          )
	        );
	      };
	
	      return Glamor.createElement(
	        'div',
	        {
	          onClick: function onClick(e) {
	            return e.stopPropagation();
	          },
	          css: _defineProperty({
	            background: 'white',
	            display: 'flex',
	            alignItems: 'stretch',
	            flexDirection: 'column',
	            width: '100%'
	          }, _glamor.presets.Tablet, {
	            flexDirection: 'row-reverse',
	            marginTop: (0, _typography.rhythm)(1)
	          })
	        },
	        Glamor.createElement(
	          'div',
	          {
	            css: _defineProperty({
	              padding: (0, _typography.rhythm)(3 / 4),
	              paddingBottom: 0
	            }, _glamor.presets.Tablet, {
	              width: (0, _typography.rhythm)(13),
	              padding: (0, _typography.rhythm)(1)
	            })
	          },
	          Glamor.createElement(UserBar, null),
	          Glamor.createElement(
	            'div',
	            {
	              css: _defineProperty({
	                display: 'none'
	              }, _glamor.presets.Tablet, {
	                display: 'block'
	              })
	            },
	            Glamor.createElement(PostDetails, null)
	          )
	        ),
	        Glamor.createElement(
	          'div',
	          {
	            to: '/' + id + '/',
	            css: {
	              display: 'block',
	              backgroundColor: 'lightgray',
	              flex: '1 0 0%',
	              width: '100%',
	              position: 'relative'
	            }
	          },
	          Glamor.createElement(
	            'div',
	            {
	              css: {
	                flexDirection: 'column',
	                flexShrink: 0,
	                position: 'relative',
	                paddingBottom: '100%',
	                overflow: 'hidden'
	              }
	            },
	            Glamor.createElement('img', {
	              key: big.src,
	              src: big.src,
	              srcSet: big.srcSet,
	              sizes: '(max-width: 640px) 100vw, 640px}',
	              css: {
	                margin: 0,
	                height: '100%',
	                width: '100%',
	                verticalAlign: 'baseline',
	                position: 'absolute',
	                top: 0,
	                bottom: 0,
	                left: 0,
	                right: 0
	              }
	            }),
	            Glamor.createElement('div', {
	              css: {
	                flexDirection: 'column',
	                flexShrink: 0,
	                position: 'absolute',
	                top: 0,
	                bottom: 0,
	                left: 0,
	                right: 0
	              }
	            })
	          )
	        ),
	        Glamor.createElement(
	          'div',
	          {
	            css: _defineProperty({
	              background: 'white',
	              padding: (0, _typography.rhythm)(3 / 4),
	              display: 'block'
	            }, _glamor.presets.Tablet, {
	              display: 'none'
	            })
	          },
	          Glamor.createElement(PostDetails, null)
	        )
	      );
	    }
	  }]);
	
	  return PostDetail;
	}(_react2.default.Component);
	
	exports.default = PostDetail;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ },

/***/ "./node_modules/charenc/charenc.js":
/***/ function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ },

/***/ "./node_modules/crypt/crypt.js":
/***/ function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ },

/***/ "./node_modules/is-buffer/index.js":
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },

/***/ "./node_modules/is-retina/index.js":
/***/ function(module, exports) {

	module.exports = function() {
	  var mediaQuery;
	  if (typeof window !== "undefined" && window !== null) {
	    mediaQuery = "(-webkit-min-device-pixel-ratio: 1.25), (min--moz-device-pixel-ratio: 1.25), (-o-min-device-pixel-ratio: 5/4), (min-resolution: 1.25dppx)";
	    if (window.devicePixelRatio > 1.25) {
	      return true;
	    }
	    if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
	      return true;
	    }
	  }
	  return false;
	};


/***/ },

/***/ "./node_modules/md5/md5.js":
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__("./node_modules/crypt/crypt.js"),
	      utf8 = __webpack_require__("./node_modules/charenc/charenc.js").utf8,
	      isBuffer = __webpack_require__("./node_modules/is-buffer/index.js"),
	      bin = __webpack_require__("./node_modules/charenc/charenc.js").bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ },

/***/ "./node_modules/react-gravatar/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _md = __webpack_require__("./node_modules/md5/md5.js");
	
	var _md2 = _interopRequireDefault(_md);
	
	var _queryString = __webpack_require__("./node_modules/query-string/index.js");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _isRetina = __webpack_require__("./node_modules/is-retina/index.js");
	
	var _isRetina2 = _interopRequireDefault(_isRetina);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gravatar = function (_React$Component) {
	  _inherits(Gravatar, _React$Component);
	
	  function Gravatar() {
	    _classCallCheck(this, Gravatar);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Gravatar).apply(this, arguments));
	  }
	
	  _createClass(Gravatar, [{
	    key: 'render',
	    value: function render() {
	      var base = this.props.protocol + 'www.gravatar.com/avatar/';
	
	      var query = _queryString2.default.stringify({
	        s: this.props.size,
	        r: this.props.rating,
	        d: this.props.default
	      });
	
	      var retinaQuery = _queryString2.default.stringify({
	        s: this.props.size * 2,
	        r: this.props.rating,
	        d: this.props.default
	      });
	
	      // Gravatar service currently trims and lowercases all registered emails
	      var formattedEmail = ('' + this.props.email).trim().toLowerCase();
	
	      var hash = void 0;
	      if (this.props.md5) {
	        hash = this.props.md5;
	      } else if (typeof this.props.email === 'string') {
	        hash = (0, _md2.default)(formattedEmail);
	      } else {
	        console.warn('Gravatar image can not be fetched. Either the "email" or "md5" prop must be specified.');
	        return _react2.default.createElement('script', null);
	      }
	
	      var src = '' + base + hash + '?' + query;
	      var retinaSrc = '' + base + hash + '?' + retinaQuery;
	
	      var modernBrowser = true; // server-side, we render for modern browsers
	
	      if (typeof window !== 'undefined') {
	        // this is not NodeJS
	        modernBrowser = 'srcset' in document.createElement('img');
	      }
	
	      var className = 'react-gravatar';
	      if (this.props.className) {
	        className = className + ' ' + this.props.className;
	      }
	
	      // Clone this.props and then delete Component specific props so we can
	      // spread the rest into the img.
	
	      var rest = _objectWithoutProperties(this.props, []);
	
	      delete rest.md5;
	      delete rest.email;
	      delete rest.protocol;
	      delete rest.rating;
	      delete rest.size;
	      delete rest.style;
	      delete rest.className;
	      delete rest.default;
	      if (!modernBrowser && (0, _isRetina2.default)()) {
	        return _react2.default.createElement('img', _extends({
	          alt: 'Gravatar for ' + formattedEmail,
	          style: this.props.style,
	          src: retinaSrc,
	          height: this.props.size,
	          width: this.props.size
	        }, rest, {
	          className: className
	        }));
	      }
	      return _react2.default.createElement('img', _extends({
	        alt: 'Gravatar for ' + formattedEmail,
	        style: this.props.style,
	        src: src,
	        srcSet: retinaSrc + ' 2x',
	        height: this.props.size,
	        width: this.props.size
	      }, rest, {
	        className: className
	      }));
	    }
	  }]);
	
	  return Gravatar;
	}(_react2.default.Component);
	
	Gravatar.displayName = 'Gravatar';
	Gravatar.propTypes = {
	  email: _react2.default.PropTypes.string,
	  md5: _react2.default.PropTypes.string,
	  size: _react2.default.PropTypes.number,
	  rating: _react2.default.PropTypes.string,
	  default: _react2.default.PropTypes.string,
	  className: _react2.default.PropTypes.string,
	  protocol: _react2.default.PropTypes.string,
	  style: _react2.default.PropTypes.object
	};
	Gravatar.defaultProps = {
	  size: 50,
	  rating: 'g',
	  default: 'retro',
	  protocol: '//'
	};
	
	
	module.exports = Gravatar;

/***/ },

/***/ "./node_modules/react-icons/lib/fa/heart.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHeart = function FaHeart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 37.1q-0.6 0-1-0.4l-13.9-13.4q-0.2-0.2-0.6-0.6t-1.3-1.4-1.5-2.2-1.2-2.7-0.5-3.1q0-4.9 2.8-7.7t7.9-2.7q1.4 0 2.8 0.4t2.7 1.3 2.1 1.6 1.7 1.5q0.8-0.8 1.7-1.5t2.1-1.6 2.7-1.3 2.8-0.4q5 0 7.9 2.7t2.8 7.7q0 4.9-5.1 10l-13.9 13.4q-0.4 0.4-1 0.4z' })
	        )
	    );
	};
	
	exports.default = FaHeart;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/template-post-page.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _postDetail = __webpack_require__("./components/post-detail.js");
	
	var _postDetail2 = _interopRequireDefault(_postDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostTemplate = function (_React$Component) {
	  _inherits(PostTemplate, _React$Component);
	
	  function PostTemplate() {
	    _classCallCheck(this, PostTemplate);
	
	    return _possibleConstructorReturn(this, (PostTemplate.__proto__ || Object.getPrototypeOf(PostTemplate)).apply(this, arguments));
	  }
	
	  _createClass(PostTemplate, [{
	    key: 'render',
	    value: function render() {
	      return (
	        // PostDetail is used for this detail page and
	        // also in the modal.
	        Glamor.createElement(_postDetail2.default, { post: this.props.data.posts })
	      );
	    }
	  }]);
	
	  return PostTemplate;
	}(_react2.default.Component);
	
	exports.default = PostTemplate;
	
	// The post template's GraphQL query. Notice the “id”
	// variable which is passed in. We set this on the page
	// context in gatsby-node.js.
	//
	// All GraphQL queries in Gatsby are run at build-time and
	// loaded as plain JSON files so have zero client cost.
	
	var pageQuery = exports.pageQuery = '\n  query PostPage($id: String!) {\n    # Select the post which equals this id.\n    posts(id: { eq: $id }) {\n      # Specify the fields from the post we need.\n      username\n      likes\n      id\n      text\n      # Date fields have special arguments. This one computes\n      # how many weeks have passed since the post was created.\n      # All calculations like this (like all GraphQL query\n      # activity) happens at build-time! So has zero cost\n      # for the client.\n      weeksAgo: time(difference: "weeks")\n      image {\n        children {\n          ... on ImageSharp {\n            # Here we query for *multiple* image thumbnails to be\n            # created. So with no effort on our part, 100s of\n            # thumbnails are created. This makes iterating on\n            # designs effortless as we simply change the args\n            # for the query and we get new thumbnails.\n            big: responsiveSizes(maxWidth: 640) {\n              src\n              srcSet\n            }\n          }\n        }\n      }\n    }\n  }\n';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }

});


// WEBPACK FOOTER //
// page-component---pages-template-post-page-js-78ac039750e3e498079a.js